import { Button } from '@mantine/core';
import ProcessMessageWithAction from 'components/ProcessMessageWithAction';
import UploadFileIcon from 'components/icons/UploadFileIcon';
import { _t } from 'lang';
import { Link } from 'react-router-dom';
import { useCostEstimateDetail } from 'pages/finance/cost-estimate/detail/CostEstimateDetailContext';

/**
 * Contains information about the state of the Cost Estimate with buttons to
 * change it when the state is `waiting-for-invoice`.
 */
export default function StateWaitingForInvoice() {
  const { links } = useCostEstimateDetail();

  return (
    <ProcessMessageWithAction
      heading={_t('Waiting for invoice')}
      message={_t('Wait until you receive the invoice from the finance department.')}
      buttons={
        <Button
          variant="primary"
          leftIcon={<UploadFileIcon stroke="#FFFFFF" />}
          component={Link}
          to={links.invoice.add}
        >
          {_t('Upload the invoice')}
        </Button>
      }
    />
  );
}
